const SENTRY_IGNORE_ERRORS_LIST = [
  /Assignment to constant variable./,
  /Attempted to assign to readonly property./,
  /Network Error/,
  /Loading CSS chunk*/,
  /Non-Error promise rejection captured*/,
] as const;

export default SENTRY_IGNORE_ERRORS_LIST;

export const SYSTEM_FONTS = [
  // ---- Universal Web-Safe Fonts ----
  { value: "Arial", label: "Arial" },
  { value: "Verdana", label: "Verdana" },
  { value: "Tahoma", label: "Tahoma" },
  { value: "Trebuchet MS", label: "Trebuchet MS" },
  { value: "Times New Roman", label: "Times New Roman" },
  { value: "Georgia", label: "Georgia" },
  { value: "Courier New", label: "Courier New" },
  { value: "Comic Sans MS", label: "Comic Sans MS" },
  { value: "Impact", label: "Impact" },

  // ---- macOS / iOS Fonts ----
  { value: "San Francisco", label: "San Francisco" },
  { value: "SF Pro Text", label: "SF Pro Text" },
  { value: "SF Pro Display", label: "SF Pro Display" },
  { value: "Helvetica Neue", label: "Helvetica Neue" },
  { value: "Helvetica", label: "Helvetica" },
  { value: "Geneva", label: "Geneva" },
  { value: "Monaco", label: "Monaco" },

  // ---- Windows Fonts ----
  { value: "Segoe UI", label: "Segoe UI" },
  { value: "Segoe UI Variable", label: "Segoe UI Variable" },
  { value: "Segoe Script", label: "Segoe Script" },
  { value: "Segoe Print", label: "Segoe Print" },
  { value: "Calibri", label: "Calibri" },
  { value: "Cambria", label: "Cambria" },
  { value: "Candara", label: "Candara" },
  { value: "Corbel", label: "Corbel" },
  { value: "Consolas", label: "Consolas" },
  { value: "Lucida Console", label: "Lucida Console" },
  { value: "Lucida Sans Unicode", label: "Lucida Sans Unicode" },
  { value: "MS Sans Serif", label: "MS Sans Serif" },
  { value: "MS Serif", label: "MS Serif" },
  { value: "Franklin Gothic Medium", label: "Franklin Gothic Medium" },
  { value: "Gadugi", label: "Gadugi" },
  { value: "Ebrima", label: "Ebrima" },
  { value: "Javanese Text", label: "Javanese Text" },
  { value: "Leelawadee UI", label: "Leelawadee UI" },
  { value: "Malgun Gothic", label: "Malgun Gothic" },
  { value: "Meiryo", label: "Meiryo" },
  { value: "Microsoft JhengHei", label: "Microsoft JhengHei" },
  { value: "Microsoft YaHei", label: "Microsoft YaHei" },
  { value: "Yu Gothic UI", label: "Yu Gothic UI" },
  { value: "Sitka", label: "Sitka" },

  // ---- Linux Fonts ----
  { value: "Ubuntu", label: "Ubuntu" },
  { value: "Cantarell", label: "Cantarell" },
  { value: "DejaVu Sans", label: "DejaVu Sans" },
  { value: "DejaVu Serif", label: "DejaVu Serif" },
  { value: "DejaVu Sans Mono", label: "DejaVu Sans Mono" },
  { value: "FreeSans", label: "FreeSans" },
  { value: "FreeSerif", label: "FreeSerif" },
  { value: "FreeMono", label: "FreeMono" },
  { value: "Noto Sans", label: "Noto Sans" },
  { value: "Noto Serif", label: "Noto Serif" },
  { value: "Noto Sans Mono", label: "Noto Sans Mono" },

  // ---- Android Fonts ----
  { value: "Roboto", label: "Roboto" },
  { value: "Roboto Condensed", label: "Roboto Condensed" },
  { value: "Droid Sans", label: "Droid Sans" },
  { value: "Droid Serif", label: "Droid Serif" },
  { value: "Droid Sans Mono", label: "Droid Sans Mono" },

  // ---- Generic Fallbacks ----
  { value: "System UI", label: "System UI" },
  { value: "-apple-system", label: "-apple-system" },
  { value: "BlinkMacSystemFont", label: "BlinkMacSystemFont" },
  { value: "Menlo", label: "Menlo" },
  { value: "Courier", label: "Courier" },
  { value: "Monospace", label: "Monospace" },
  { value: "Serif", label: "Serif" },
  { value: "Sans-serif", label: "Sans-serif" },
];
